import { useDispatch } from 'react-redux';

import type { AppDispatch } from 'store/storeConfig';

/** `useDispatch` typed for this store, so thunks dispatch without an `any`. */
const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
